var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quillText"},[_c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.quillOption},nativeOn:{"click":function($event){return _vm.handleEditAblequestion.apply(null, arguments)}},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }